const { makeVar } = require('@apollo/client');

export const dashboardSearchVar = makeVar('');
